import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText, Receipt, Printer, Download } from "lucide-react";

interface PrintOptionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectOption: (type: 'thermal' | 'a4', action: 'print' | 'download') => void;
}

export function PrintOptionsDialog({
  open,
  onOpenChange,
  onSelectOption,
}: PrintOptionsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Printer className="h-5 w-5" />
            Print / Download Options
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* A4 Options */}
          <div className="space-y-2">
            <h3 className="text-sm font-semibold flex items-center gap-2">
              <FileText className="h-4 w-4" />
              A4 Size (Standard Invoice)
            </h3>
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant="outline"
                className="h-12 gap-2"
                onClick={() => {
                  onSelectOption('a4', 'print');
                  onOpenChange(false);
                }}
              >
                <Printer className="h-4 w-4" />
                Print A4
              </Button>
              <Button
                variant="outline"
                className="h-12 gap-2"
                onClick={() => {
                  onSelectOption('a4', 'download');
                  onOpenChange(false);
                }}
              >
                <Download className="h-4 w-4" />
                Download A4
              </Button>
            </div>
          </div>

          {/* Thermal Options */}
          <div className="space-y-2">
            <h3 className="text-sm font-semibold flex items-center gap-2">
              <Receipt className="h-4 w-4" />
              Thermal (58mm/80mm Receipt)
            </h3>
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant="outline"
                className="h-12 gap-2"
                onClick={() => {
                  onSelectOption('thermal', 'print');
                  onOpenChange(false);
                }}
              >
                <Printer className="h-4 w-4" />
                Print Thermal
              </Button>
              <Button
                variant="outline"
                className="h-12 gap-2"
                onClick={() => {
                  onSelectOption('thermal', 'download');
                  onOpenChange(false);
                }}
              >
                <Download className="h-4 w-4" />
                Download Thermal
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
